module.exports = __webpack_public_path__ + "img/24.6.CODm.bd3f115f.png";